module.exports = __webpack_public_path__ + "img/big4-7.8b542776.jpg";